import { Directive, HostListener, Input } from '@angular/core';
import { CommonService } from '../services/common.service';

declare var smartech: any;
declare var clevertap: any;

@Directive({
    selector: '[eventTracker]'
})
export class ButtonDirective {
    constructor(public commonService: CommonService) {
    }

    @Input('eventTracker') option: any;

    @HostListener('click', ['$event']) onClick($event) {
        if (this.option) {
            // const data = {
            //     EventName: this.option.evnetName,
            //     Parameter: JSON.stringify(this.option.param),
            //     timestamp: new Date()
            // };
            // this.commonService.createCoffeeOrder(data).then(res => {
            //     console.log('success store');
            // });
            this.commonService.logEvent(this.option.evnetName, this.option.param, this.option.category);

            // clevertap.event.push(this.option.evnetName, this.option.param, this.option.category);

            // if (this.option.category) {
            //     setTimeout(() => {
            //         // this.option = null;
            //         // smartech('dispatch', this.option.evnetName, this.option.param);
            //     });
            // } else {
            //     smartech('dispatch', this.option.evnetName, this.option.param);
            // }
        }
    }
}
